import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Typography, Button } from '@material-ui/core';
import { Virtuoso } from 'react-virtuoso';
import useStyles from './styles';

import { convertObjToArr } from '../../../utils';
import Comment from '../../../components/Comment';
import Actions from '../../../store/ducks/annotations';
import NoteItem from './NoteItem';

const Notes = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    list: annotationsObj,
    error: annotationsError,
    allLoaded,
  } = useSelector(state => state.annotations);
  const courses = useSelector(({ course }) => course.list);
  const [myAnnotationsArr, setMyAnnotationsArr] = useState([]);

  const handleRequestAnnotations = useCallback(
    () => dispatch(Actions.requestAllAnnotations()),
    [dispatch],
  );

  useEffect(() => {
    setMyAnnotationsArr(convertObjToArr(annotationsObj));
  }, [annotationsObj]);

  useEffect(() => {
    if (!allLoaded) {
      handleRequestAnnotations();
    }
  }, [allLoaded, handleRequestAnnotations]);

  const GenerateNoteItem = index => {
    const { description, createdAt, lessonId, courseId } = myAnnotationsArr[
      index
    ];

    const order = (() => {
      const courseItem = courses[courseId];
      if (!courseItem || !courseItem.lessons || !courseItem.lessons[lessonId]) {
        return '';
      }
      return courseItem.lessons[lessonId]?.order;
    })();

    return (
      <>
        {index === 0 && <Box className="list-top-spacing" />}
        <NoteItem
          description={description}
          createdAt={createdAt}
          courseId={courseId}
          lessonId={lessonId}
          courseName={courses[courseId]?.name}
          lessonOrder={order}
        />
      </>
    );
  };

  const statusList = useMemo(() => {
    if (!annotationsError && !allLoaded) {
      return 'LOADING';
    }
    if (!annotationsError && allLoaded && !myAnnotationsArr.length) {
      return 'EMPTY';
    }
    if (!annotationsError && allLoaded && !!myAnnotationsArr.length) {
      return 'FILLED';
    }
    return 'ERROR';
  }, [allLoaded, annotationsError, myAnnotationsArr.length]);

  return (
    <Box className={classes.container}>
      {statusList === 'LOADING' && (
        <Box className="annotations-loading-container">
          <Comment isLoading />
        </Box>
      )}
      {statusList === 'ERROR' && (
        <>
          <Typography variant="body2" className="annotations-message">
            Não foi possível carregar suas anotações
          </Typography>
          <Button
            size="small"
            color="primary"
            onClick={handleRequestAnnotations}
            className="annotations-button-retry"
          >
            Tentar novamente
          </Button>
        </>
      )}
      {statusList === 'EMPTY' && (
        <Typography variant="body2" className="annotations-message">
          Você ainda não fez nenhuma anotação
        </Typography>
      )}
      {statusList === 'FILLED' && (
        <Virtuoso
          className="annotations-list-container"
          totalCount={myAnnotationsArr.length}
          overscan={200}
          item={GenerateNoteItem}
        />
      )}
    </Box>
  );
};

export default Notes;
